module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/EEf0e7/tc-custom/9780811871716.jpg?1702206957595",
      "alt": "This image is the cover for the book DIY Wedding"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("DIY Wedding\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("Practical, inspiring ideas for making your wedding more meaningful—and less money-draining.")]), _c('br'), _c('br'), _vm._v("Goodbye, caterers. So long, wedding coordinators. Here is the bride’s guide to thinking outside the wedding-industry box. "), _c('br'), _c('br'), _vm._v("In this, the only comprehensive do-it-yourself wedding book, you’ll find everything you need to pull off a personalized celebration. No cookie-cutter weddings here! "), _c('br'), _c('br'), _vm._v("With how-to info on flowers, invites, food, the ceremony, and more, "), _c('i', [_vm._v("The DIY Wedding")]), _vm._v(" makes it easy to spend less and create an event that is entirely original. Inspiring ideas, countless resources, budgeting tips, contract templates, plus start-to-finish projects ease the planning pressure. Say “I do”—do-it-yourself style!\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Kelly Bare, Natalie Zee Drieu\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Kelly Bare was a founding editor of the relationship magazine Tango and is the author of The F Word: A Fiancée Shares Her Story, From \"I Will\" to \"I Do.\" She has written for Modern Bride, among other wedding magazines, and pulled off her own DIY wedding in Nebraska. She and her husband live in New York City. Visit her at www.thediywedding.com.Natalie Zee Drieu lives in the San Francisco Bay Area and is an associate editor of CRAFT magazine.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Chronicle Books\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0